import React from 'react';
import { Icon } from '@iconify/react';
import Modal from '../../theme/components/Modal';
import styles from './AffiliationModal.module.scss';

/**
 * 🎨 Modal de Afiliação - Design Moderno
 * 
 * Modal elegante para exibir resultados de solicitação de afiliação
 * com design moderno seguindo os padrões do projeto.
 */

const AffiliationModal = ({
  show,
  onHide,
  productName,
  isSuccess,
  message,
  autoApproved = false
}) => {
  const getModalConfig = () => {
    if (isSuccess && autoApproved) {
      return {
        icon: 'solar:check-circle-bold',
        title: 'Parabéns! 🎉',
        subtitle: 'Você agora é afiliado deste produto!',
        buttonVariant: 'success',
        buttonIcon: 'solar:check-circle-bold',
        infoCardVariant: 'success'
      };
    } else if (isSuccess) {
      return {
        icon: 'solar:clock-circle-bold',
        title: 'Solicitação Enviada! ⏳',
        subtitle: 'Aguarde a aprovação do produtor',
        buttonVariant: 'primary',
        buttonIcon: 'solar:check-circle-bold',
        infoCardVariant: 'warning'
      };
    } else {
      return {
        icon: 'solar:danger-triangle-bold',
        title: 'Ops! Algo deu errado 😕',
        subtitle: 'Tente novamente em alguns instantes',
        buttonVariant: 'primary',
        buttonIcon: 'solar:check-circle-bold',
        infoCardVariant: 'danger'
      };
    }
  };

  const config = getModalConfig();

  return (
    <Modal
      show={show}
      onHide={onHide}
      title={config.title}
      icon={config.icon}
      size="md"
      centered
      footer={
        <Modal.Button 
          variant={config.buttonVariant}
          onClick={onHide}
          icon={config.buttonIcon}
          fullWidth
        >
          Entendi
        </Modal.Button>
      }
    >
      <div className={styles.content}>
        {/* Ícone Grande */}
        <div className={styles.iconContainer}>
          <Icon 
            icon={config.icon} 
            className={`${styles.icon} ${styles[config.buttonVariant]}`}
          />
        </div>

        {/* Subtítulo */}
        <p className={styles.subtitle}>
          {config.subtitle}
        </p>

        {/* Nome do Produto */}
        {productName && (
          <div className={styles.productBadge}>
            <Icon icon="solar:tag-bold" className={styles.badgeIcon} />
            <span className={styles.productName}>{productName}</span>
          </div>
        )}

        {/* Mensagem */}
        {message && (
          <p className={styles.message}>
            {message}
          </p>
        )}

        {/* Informações Adicionais */}
        {isSuccess && !autoApproved && (
          <Modal.InfoCard variant={config.infoCardVariant}>
            <div className={styles.infoContent}>
              <Icon icon="solar:info-circle-bold" className={styles.infoIcon} />
              <div className={styles.infoText}>
                <span className={styles.infoTitle}>Próximos passos:</span>
                <ul className={styles.infoList}>
                  <li>O produtor será notificado sobre sua solicitação</li>
                  <li>Você receberá um e-mail quando for aprovado</li>
                  <li>O status será atualizado na página do produto</li>
                </ul>
              </div>
            </div>
          </Modal.InfoCard>
        )}
      </div>
    </Modal>
  );
};

export default AffiliationModal;